import { render, staticRenderFns } from "./Informative.vue?vue&type=template&id=69ed413e&scoped=true"
import script from "./Informative.vue?vue&type=script&lang=js"
export * from "./Informative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ed413e",
  null
  
)

export default component.exports